import React, { useEffect, useRef, useState } from 'react';
import { View, Heading, colors, GridColumn } from '@fairygodboss/ui';
import { Author } from '../../../SharedComponents/ContentBody/Author';
import { useCommunityContent } from '../../CommunityPostContentContext';

export const breakpoints = {
    desktop: {
        width: 669,
        transforms: {
            quality: 'auto',
            crop: 'scale',
            format: 'auto',
        },
    },
    tablet: {
        width: 750,
        transforms: {
            quality: 'auto',
            crop: 'scale',
            format: 'auto',
        },
    },
    smallTablet: {
        width: 665,
        transforms: {
            quality: 'auto',
            crop: 'scale',
            format: 'auto',
        },
    },
    mobile: {
        width: 567,
        transforms: {
            quality: 'auto',
            crop: 'scale',
            format: 'auto',
        },
    },
};

export const ContentInfo = () => {
    const {
        author,
        contentModifiedDate,
        windowWidth,
        contentDescription,
        hash,
        didEdit,
        type,
        backgroundHeight,
        deleted,
        content,
        isCommunityDiscussionType,
        publishDate,
        contentDate,
    } = useCommunityContent();
    const [authorPaddingTop, setAuthorPaddingTop] = useState(28);
    const authorRef = useRef();

    useEffect(() => {
        if (!authorRef.current) {
            return;
        }
        if (windowWidth < 970 && windowWidth > 904) {
            const offsetHeight = authorRef?.current.offsetTop;
            if (offsetHeight < backgroundHeight) {
                const padding = backgroundHeight - offsetHeight + 28;
                if (authorPaddingTop !== padding) {
                    setAuthorPaddingTop(28);
                }
            }
        } else if (authorPaddingTop !== 28) {
            setAuthorPaddingTop(28);
        }
    }, [authorRef, backgroundHeight, windowWidth, authorPaddingTop]);

    return (
        <View
            display="flex"
            justifyContent="space-between"
            css={{
                a: {
                    textDecoration: 'none',
                    ':hover': {
                        color: `${colors.primary[60]} !important`,
                    },
                    ':visited': {
                        color: `${colors.primary[60]} !important`,
                    },
                },
            }}
        >
            <GridColumn
                size={{ xs: 12, sm: 12, md: 7.8, lg: 7.6 }}
                css={{ paddingLeft: '0px', paddingRight: '0px' }}
            >
                {contentDescription?.length ? (
                    <Heading
                        pt="24px"
                        variant="headingSm"
                        fontWeight="600"
                        fontSize={{ _: '16px', md: '20px' }}
                        lineHeight={{ _: '24px', md: '30px' }}
                        color={colors.neutral[100]}
                        as="h2"
                    >
                        {contentDescription}
                    </Heading>
                ) : null}
                {!deleted ? (
                    <Author
                        pt={`${authorPaddingTop}px`}
                        author={author}
                        didEdit={didEdit}
                        type={type}
                        hash={hash}
                        contentModifiedDate={contentModifiedDate}
                        windowWidth={windowWidth}
                        ref={authorRef}
                        content={content}
                        publishDate={publishDate}
                        contentDate={contentDate}
                        isCommunityDiscussionType={isCommunityDiscussionType}
                    />
                ) : null}
            </GridColumn>

            <GridColumn
                size={{
                    xs: 0,
                    sm: 0,
                    md: windowWidth > 1054 ? 3 : 4,
                    lg: 3.05,
                }}
                pr={{ _: '0px', md: '24px', lg: '0px' }}
                css={{
                    paddingLeft: '0px',
                }}
            />
        </View>
    );
};

ContentInfo.displayName = 'ContentInfo';
